import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledGainAccessContainer = styled.div`
    display: flex;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 44px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    border-radius: 6px;
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
`;

export const StyledGainAccessTitle = styled.div`
    display: flex;
    margin-top: 24px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const StyledGainAccessSubTitle = styled.div`
    display: flex;
    margin-top: 8px;
    text-align: center;
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
`;

export const StyledGainAccessBtnWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;
